module.exports = __webpack_public_path__ + "static/2cf70457.step3.png";